module.exports = __webpack_public_path__ + "static/media/19.7c4b244d.jpg";